$(function () {

    const urlParams = new URLSearchParams(window.location.search)

    $('.preference-center-modal').kendoWindow({
        size: 'small',
        title: {
            text: 'Unsubscribe'
        },
        modal: {
            preventScroll: true
        },
        position: {
            top: '50%',
            left: '50%'
        },
        visible: urlParams.get('unsubscribe') ?? false,
        resizable: false,
    })

    $('.preference-center-modal__toggle').on('click touch', () => {
        $('.preference-center-modal').data('kendoWindow').open()
    })
})